export default {
  data() {
    return {
      isMounted: false,
    }
  },

  mounted() {
    this.isMounted = true
    this.$emit('mounted', this)
  },
}
